import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { map, Observable, of, withLatestFrom } from 'rxjs';
import { AuthService } from './services/auth.service';
import { RefreshToken } from './store/auth/auth.classes';
import { AuthSelectors } from './store/auth/auth.selectors';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  @Select(AuthSelectors.accessToken) accessToken$!: Observable<string | null>;

  constructor(
    protected router: Router,
    protected store: Store,
    protected authService: AuthService
  ) { }

  canActivate(): Observable<boolean | UrlTree> {
    if (this.authService.isAuthenticated()) {
      return of(true);
    }

    return this.store.dispatch(new RefreshToken()).pipe(
      withLatestFrom(this.accessToken$),
      map(([_, accessToken]) => {
        if (accessToken) return true;
        return this.goPage();
      })
    );
  }

  protected goPage() {
    return this.router.parseUrl('/login');
  }
}
